import { getFilePath } from "../../../utils";
import { ResponsiveImage } from "../ResponsiveImage";
import { SectionTitle } from "./SectionTitle";
import clsx from "clsx";
import { MAX_CONTAINER_WIDTH } from "./constants";
import { ExpandableCourseList } from "./ExpandableCourseList";
import { usePublishedCoursesQuery } from "./usePublishedCoursesQuery";

export const MainCoursesList: React.FC = () => {
  const { data: courseData } = usePublishedCoursesQuery();

  const featuredCourses = courseData?.courses
    ?.filter((c) => c.featuredCourseOrder !== undefined)
    .sort(
      (a, b) => (a.featuredCourseOrder ?? 0) - (b.featuredCourseOrder ?? 0)
    );

  return (
    <section
      className={clsx(
        "relative flex w-full flex-col items-center px-4 md:px-6 xl:px-0",
        MAX_CONTAINER_WIDTH
      )}
    >
      <SectionTitle
        title="Your Math Journey Starts Here"
        subtitle="Find the perfect course to match your grade and goals"
      />

      <ExpandableCourseList
        courseGroups={courseData?.groups}
        getCourses={(isExpanded) =>
          isExpanded ? courseData?.courses : featuredCourses
        }
        getButtonText={(isExpanded) =>
          isExpanded ? "Hide Courses" : "Explore All Courses"
        }
      />

      <ResponsiveImage
        className="absolute -left-10 -top-10 hidden md:block 2xl:-left-28"
        srcs={[
          getFilePath("/images/learner/home/pencil.png"),
          getFilePath("/images/learner/home/pencil@2x.png"),
        ]}
        alt="Pencil"
      />
    </section>
  );
};
